module.exports = ":host /deep/ .ui-card-title {\n  text-align: center; }\n\n.login-panel {\n  width: 400px;\n  margin: 100px auto 0; }\n"